var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInteractiveProposalHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1446,
    height: 76,
    viewBox: "0 0 1446 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_13905)",
    filter: "url(#filter0_d_1044_13905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 70,
    transform: "matrix(1 0 0 -1 3 72)",
    fill: "white",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1044_13905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.78 53.3234C379.051 71.5758 246.646 131.136 200.41 158.635L205.656 216.952L1149.52 55.7778L1141.88 -29.1193C1133.04 -34.4563 1091.81 -31.6064 997.706 22.4887C880.072 90.1075 738.441 30.5079 538.78 53.3234Z",
    fill: "url(#paint0_linear_1044_13905)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1044_13905",
    x: 0,
    y: 0,
    width: 1446,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0901961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1044_13905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1044_13905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1044_13905",
    x: 62.1102,
    y: -169.3,
    width: 1225.71,
    height: 524.552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 69.15,
    result: "effect1_foregroundBlur_1044_13905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_13905",
    x1: 200.866,
    y1: 163.7,
    x2: 1151.54,
    y2: 78.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADEFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_13905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 70,
    fill: "white",
    transform: "matrix(1 0 0 -1 3 72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveProposalHeader);
export default __webpack_public_path__ + "static/media/interactive-proposal-header.0a71b1a00eabc78ff96a60f04a577f92.svg";
export { ForwardRef as ReactComponent };